// ABOUTME: Transformation schema mapping Rusada scheduled maintenance to TechLog scheduled MX items.
import type { RusadaToTechlogScheduledMxItemInput } from './validation';

const rusadaScheduledMxItemToTechlogSchema = {
  name: (input: RusadaToTechlogScheduledMxItemInput) =>
    `${input.rusada.scheduledMaintenance.mi} - ${input.rusada.scheduledMaintenance.title}`,

  details: (input: RusadaToTechlogScheduledMxItemInput) =>
    input.rusada.scheduledMaintenance.title,

  aircraftId: (input: RusadaToTechlogScheduledMxItemInput) =>
    input.techlog.aircraft.id,

  dueDate: (input: RusadaToTechlogScheduledMxItemInput) =>
    input.rusada.scheduledMaintenance.dueDate || undefined,

  dueFlightSeconds: (input: RusadaToTechlogScheduledMxItemInput) => {
    const parsed = input.rusada.parsedNextDue;
    if (!parsed || parsed.unit !== 'FH') return undefined;
    return Math.round(parsed.value * 3600);
  },

  dueCycles: (input: RusadaToTechlogScheduledMxItemInput) => {
    const parsed = input.rusada.parsedNextDue;
    if (!parsed || parsed.unit !== 'EC') return undefined;
    return Math.round(parsed.value);
  },

  // dueLandings intentionally omitted: TechLog has no dashboard counter for landings,
  // no overdue logic for landings totals, and the field is slated for removal.
  // TOTAL_LANDINGS items are still synced — they rely on dueDate for tracking.

  reference: (input: RusadaToTechlogScheduledMxItemInput) =>
    input.rusada.scheduledMaintenance.mi,

  operatorReference: (input: RusadaToTechlogScheduledMxItemInput) =>
    `Veryon-${input.rusada.scheduledMaintenance.id}`,

  draft: () => false,

  mxType: () => 'airframe_scheduled',
};

export default rusadaScheduledMxItemToTechlogSchema;
